<div class="pgp-page">

  <!-- Flash -->
  <div class="pgp-flash"
    [class.pgp-flash--success]="messageFlash.type === 'success'"
    [class.pgp-flash--error]="messageFlash.type === 'error'"
    *ngIf="messageFlash">
    {{ messageFlash.texte }}
  </div>

  <!-- Entête -->
  <div class="pgp-header">
    <button class="pgp-back-btn" (click)="annuler()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
      Retour à la liste
    </button>
    <h2 class="pgp-title">
      {{ modeEdition ? 'Modifier le partenaire' : 'Nouveau partenaire' }}
    </h2>
    <p class="pgp-subtitle">
      {{ modeEdition ? 'Modifiez les informations du partenaire ou sous-traitant.' : 'Ajoutez un nouveau sous-traitant ou partenaire de transport.' }}
    </p>
  </div>

  <!-- Loader -->
  <div class="pgp-loading" *ngIf="chargement">
    <div class="pgp-spinner"></div>
    <span>Chargement…</span>
  </div>

  <!-- Formulaire -->
  <form class="pgp-form" [formGroup]="formulaire" (ngSubmit)="soumettre()" *ngIf="!chargement">

    <!-- Section 1 : Propriétaire -->
    <div class="pgp-section">
      <div class="pgp-section-label">
        <span class="pgp-section-num">1</span>
        Informations du propriétaire
      </div>
      <div class="pgp-grid-2">
        <div class="pgp-field" [class.pgp-field--error]="estInvalide('nomProprietaire')">
          <label>Nom du propriétaire <span class="pgp-req">*</span></label>
          <input formControlName="nomProprietaire" type="text" placeholder="Ex : Kouamé Adjoua">
          <span class="pgp-err-msg" *ngIf="estInvalide('nomProprietaire')">Champ obligatoire</span>
        </div>
        <div class="pgp-field" [class.pgp-field--error]="estInvalide('contactProprietaire')">
          <label>Contact <span class="pgp-req">*</span></label>
          <input formControlName="contactProprietaire" type="text" placeholder="Ex : +225 07 12 34 56">
          <span class="pgp-err-msg" *ngIf="estInvalide('contactProprietaire')">Champ obligatoire</span>
        </div>
      </div>
    </div>

    <!-- Section 2 : Véhicule -->
    <div class="pgp-section">
      <div class="pgp-section-label">
        <span class="pgp-section-num">2</span>
        Informations du véhicule
      </div>
      <div class="pgp-grid-3">
        <div class="pgp-field" [class.pgp-field--error]="estInvalide('immatriculation')">
          <label>Immatriculation <span class="pgp-req">*</span></label>
          <input formControlName="immatriculation" type="text" placeholder="Ex : AB-1234-CI">
          <span class="pgp-err-msg" *ngIf="estInvalide('immatriculation')">Champ obligatoire</span>
        </div>
        <div class="pgp-field" [class.pgp-field--error]="estInvalide('marque')">
          <label>Marque <span class="pgp-req">*</span></label>
          <input formControlName="marque" type="text" placeholder="Ex : Yamaha">
          <span class="pgp-err-msg" *ngIf="estInvalide('marque')">Champ obligatoire</span>
        </div>
        <div class="pgp-field" [class.pgp-field--error]="estInvalide('modele')">
          <label>Modèle <span class="pgp-req">*</span></label>
          <input formControlName="modele" type="text" placeholder="Ex : FZ-S">
          <span class="pgp-err-msg" *ngIf="estInvalide('modele')">Champ obligatoire</span>
        </div>
        <div class="pgp-field">
          <label>Couleur</label>
          <input formControlName="couleur" type="text" placeholder="Ex : Rouge">
        </div>
        <div class="pgp-field pgp-field--span2" [class.pgp-field--error]="estInvalide('numeroChassis')">
          <label>N° de châssis <span class="pgp-req">*</span></label>
          <input formControlName="numeroChassis" type="text" placeholder="Ex : JN1FDNJ1J0574930">
          <span class="pgp-err-msg" *ngIf="estInvalide('numeroChassis')">Champ obligatoire</span>
        </div>
      </div>
    </div>

    <!-- Section 3 : Contrat -->
    <div class="pgp-section">
      <div class="pgp-section-label">
        <span class="pgp-section-num">3</span>
        Type de contrat &amp; rémunération
      </div>

      <!-- Sélecteur contrat -->
      <div class="pgp-contrat-choix">
        <label class="pgp-contrat-card" [class.pgp-contrat-card--selected]="typeContrat === 'PAR_LIVRAISON'">
          <input type="radio" formControlName="typeContrat" value="PAR_LIVRAISON" hidden>
          <div class="pgp-contrat-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24">
              <rect x="1" y="3" width="15" height="13" rx="2"/>
              <path d="M16 8h4l3 5v4h-7V8z"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
          </div>
          <div class="pgp-contrat-info">
            <strong>Par livraison</strong>
            <span>Montant fixe par course effectuée</span>
          </div>
          <div class="pgp-contrat-check">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </label>

        <label class="pgp-contrat-card" [class.pgp-contrat-card--selected]="typeContrat === 'MENSUEL'">
          <input type="radio" formControlName="typeContrat" value="MENSUEL" hidden>
          <div class="pgp-contrat-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </div>
          <div class="pgp-contrat-info">
            <strong>Mensuel fixe</strong>
            <span>Forfait mensuel indépendant des courses</span>
          </div>
          <div class="pgp-contrat-check">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </label>

        <label class="pgp-contrat-card" [class.pgp-contrat-card--selected]="typeContrat === 'HYBRIDE'">
          <input type="radio" formControlName="typeContrat" value="HYBRIDE" hidden>
          <div class="pgp-contrat-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
          </div>
          <div class="pgp-contrat-info">
            <strong>Hybride</strong>
            <span>Forfait mensuel + prime par livraison</span>
          </div>
          <div class="pgp-contrat-check">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </label>
      </div>

      <!-- Champs montants selon contrat -->
      <div class="pgp-grid-2" style="margin-top: 16px;">
        <div class="pgp-field" *ngIf="typeContrat === 'PAR_LIVRAISON' || typeContrat === 'HYBRIDE'"
          [class.pgp-field--error]="estInvalide('montantParLivraison')">
          <label>Montant par livraison (FCFA) <span class="pgp-req">*</span></label>
          <input formControlName="montantParLivraison" type="number" min="0" placeholder="Ex : 2000">
          <span class="pgp-err-msg" *ngIf="estInvalide('montantParLivraison')">Montant obligatoire</span>
        </div>
        <div class="pgp-field" *ngIf="typeContrat === 'MENSUEL' || typeContrat === 'HYBRIDE'"
          [class.pgp-field--error]="estInvalide('montantMensuel')">
          <label>Forfait mensuel (FCFA) <span class="pgp-req">*</span></label>
          <input formControlName="montantMensuel" type="number" min="0" placeholder="Ex : 50000">
          <span class="pgp-err-msg" *ngIf="estInvalide('montantMensuel')">Montant obligatoire</span>
        </div>
      </div>
    </div>

    <!-- Section 4 : Disponibilité -->
    <div class="pgp-section">
      <div class="pgp-section-label">
        <span class="pgp-section-num">4</span>
        Disponibilité initiale
      </div>
      <div class="pgp-toggles">
        <label class="pgp-toggle-row">
          <div class="pgp-toggle-info">
            <span class="pgp-toggle-lbl">En service</span>
            <span class="pgp-toggle-desc">Le partenaire est opérationnel et peut recevoir des missions</span>
          </div>
          <label class="pgp-switch">
            <input type="checkbox" formControlName="enService">
            <span class="pgp-switch-track"></span>
          </label>
        </label>
        <label class="pgp-toggle-row">
          <div class="pgp-toggle-info">
            <span class="pgp-toggle-lbl">Disponible</span>
            <span class="pgp-toggle-desc">Libre pour une nouvelle mission immédiatement</span>
          </div>
          <label class="pgp-switch">
            <input type="checkbox" formControlName="disponible">
            <span class="pgp-switch-track"></span>
          </label>
        </label>
      </div>
    </div>

    <!-- Actions -->
    <div class="pgp-actions">
      <button type="button" class="pgp-btn pgp-btn--ghost" (click)="annuler()">Annuler</button>
      <button type="submit" class="pgp-btn pgp-btn--primary" [disabled]="soumission">
        <div class="pgp-btn-spinner" *ngIf="soumission"></div>
        <svg *ngIf="!soumission" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ soumission ? 'Enregistrement…' : (modeEdition ? 'Mettre à jour' : 'Enregistrer le partenaire') }}
      </button>
    </div>

  </form>
</div>
